import videojs from 'video.js'

videojs.addLanguage('sq', {
  // custom albanian translations
  'Try again': 'Provo përsëri',
  'button_try_again_in': 'Provo sërish pas {1}',
  'too_many_streams_title': 'Shumë transmetime',
  'stream_limit_exceeded_message':
    'Abonimi yt lejon {1} transmetime të njëkohshme. Ju lutemi ndaloni riprodhimin në një pajisje tjetër dhe provoni përsëri.',
})
